export default __webpack_public_path__ + "static/media/list.b76cdb02.png";